var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-table',{ref:"table",attrs:{"fields":_vm.fields,"with-items":"","settings":false,"items":_vm.employees}})}
var staticRenderFns = []

export { render, staticRenderFns }